import React from 'react';
import {Grid } from '@mui/material';
import styles from 'styles/informacionDelCard';
import TituloConIcono from 'components/tituloConIcono';
import ElementoDelCard from 'components/card/ElementoDelCard';

const Escrito = ({escritos}) => {
  const classes = styles();

  return (
    <div className={classes.root}>
      <Grid container spacing={2} justifyContent="flex-start" alignItems="stretch">
        {escritos.map((escrito, index) => (
          <Grid item xs={12} key={escrito?.id || index}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TituloConIcono title={"Tipo de medio escrito"} mostrarTiempo={false} mostrarBotones={false} showIcon={false} />
                <ElementoDelCard title={'Tipo:'} label={ escrito.tipoDeMedioEscrito?.descripcion || ""}/>
              </Grid>
              <Grid item xs={12}>
                <TituloConIcono title={"Edicion de medio escrito"} mostrarTiempo={false} mostrarBotones={false} showIcon={false} />
                <ElementoDelCard title={'Tipo:'} label={ escrito.tipoDeCirculacionDeMedioEscrito?.descripcion || ""}/>
                <ElementoDelCard title={'Sitio web:'} label={ escrito.enlaceWeb || ""}/>
              </Grid>
            </Grid>
          </Grid>
        ))}
      </Grid>
    </div>
  );
}

export default Escrito;